<div ngbDropdown display="dynamic" placement="bottom-right">
  <button ngbDropdownToggle class="dropdown-btn">
    <i class="fa fa-user dropdown-icon-white"></i>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="dropdown-menu-container profile-menu-dropdown-container">
    <div class="dropdown-item">{{userName}}</div>
    <a class="dropdown-item" href="#">Logout</a>
  </div>
</div>